import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

import { TranslocoDirective } from '@jsverse/transloco';

import { UserConfigsStoreFacade } from '../../../stores/global-store/user-configs/user-configs-store.facade';
import { SidebarDisplayStore } from '../../../stores/signal-stores/sidebar-display-store/sidebar-display.store';

@Component({
  selector: 'app-navigation-country-switch',
  imports: [
    NgOptimizedImage,
    MatIconModule,
    MatButtonModule,
    TranslocoDirective,
    MatTooltipModule
  ],
  templateUrl: './navigation-country-switch.component.html',
  styleUrl: './navigation-country-switch.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class NavigationCountrySwitchComponent {

  public userConfigsFacade = inject(UserConfigsStoreFacade);
  public sidebarDisplayStore = inject(SidebarDisplayStore);

  public onSwitchClicked(): void {
    if (this.userConfigsFacade.isSuperAdminSignal() || this.userConfigsFacade.isInternalUserSignal()) {
      this.userConfigsFacade.isExternalViewSignal() ? this.sidebarDisplayStore.showSwitchViewSidebar() :
        this.sidebarDisplayStore.showCountrySwitchSidebar();
      return;
    }

    if (this.userConfigsFacade.isExternalUserSignal()) {
      this.sidebarDisplayStore.showSwitchExternalUserSidebar();
      return;
    }
  }
}
